class plcategory {
    constructor(name, datakey, pricelist, dependency = false){
        this.name = name;
        this.options = [];
        this.undoOptions = [];
        this.userSelected = [];
        this.apiendpoint = '/wp-json/api/v1/' + datakey + '/';
        this.datakey = datakey;
        this.pricelist = pricelist;
        this.dependency = dependency;
        this.status = 'disabled';
        this.isOpen = false;
        this.tooltip = null;

        if (!this.dependency && this.datakey != 'logcharging' ){
            this.getOptions()
        }
    }

    // http://rubikon-web8.at/wp-json/api/v1/

    view() {
        return $(this.getSelector());
    }

    getSelector(){
        return `.pricelist[data-key='${this.pricelist.id}'] .dropdown[data-key="${this.datakey}"]`;
    }

    getNavSelector(){
        return `.pricelist[data-key='${this.pricelist.id}'] .nav a[data-key="${this.datakey}"]`;
    }

    openDropdown(){
        if (this.status == 'disabled'){
            return false;
        }
        this.undoOptions = JSON.parse(JSON.stringify(this.options));
        this.pricelist.plcategories.map(x=> {
            if ( x.isOpen ){
                x.closeDropdown();
            }
        })
        this.view().addClass('show');
        this.pricelist.view().find('.nav a[data-key='+this.datakey+']').addClass('open');
        this.isOpen = true;
    }

    closeDropdown(){
        // this.pricelist.temporaryUserOptions = JSON.parse(JSON.stringify(this.pricelist.useroptions));
        if (JSON.stringify(this.options) != JSON.stringify(this.undoOptions)){
            this.options = this.undoOptions;
            this.getOptions();
        }

        // this.renderAuswahl();
        this.view().removeClass('show');
        this.pricelist.view().find('.nav a[data-key='+this.datakey+']').removeClass('open');
        this.isOpen = false;
    }

    confirmSelection(){
        this.renderAuswahl();
        // this.pricelist.updateUseroptions();
        this.loadDependent();
        this.view().removeClass('show');
        this.pricelist.view().find('.nav a[data-key='+this.datakey+']').removeClass('open');
        this.isOpen = false;
        this.pricelist.canBeSaved();
        this.pricelist.isDirty = true;
        this.pricelist.view().find('a.download-pricelist').addClass('disabled');
        if ( this.datakey === 'categories' ) {
            if ( this.options.find( x=> x.id == 31 && x.isSelected == true ) ) {
                this.pricelist.plcategories.find(x=> x.datakey == 'logcharging').getOptions();
            }
        }
    }

    setStatus(status){
        this.status = status;
        this.view().removeClass('disabled loading');
        this.view().addClass(status);
        $(this.getNavSelector()).removeClass('disabled loading');
        $(this.getNavSelector()).addClass(status);
    }

    getSelected(){
        return this.options.filter(x=> x.isSelected);
    }

    //tooltips

    getOptions(){
        let self = this;
        this.setStatus('loading disabled');
        this.view().find('ul.select').html('')
        let data = {};

        if (!this.dependency === false ){
            let dependent = this.pricelist.plcategories.find(x=> x.datakey == this.dependency);
            let dependendata = dependent.getSelected();
            data = {id: [] }
            dependendata.forEach(el => data.id.push(el.id));

            if ( data.id.length < 1 ){
                this.setStatus('disabled');
                this.renderAuswahl();
                self.loadDependent();
                return false;
            }
        }

        $.ajax({
            type: 'post',
            url: self.apiendpoint,
            beforeSend: function(xhr) {
                if (typeof nonce != "undefined") {
                    xhr.setRequestHeader('X-WP-Nonce', nonce);
                }
            },
            data: data,
            success: function (data) {
                self.userSelected = self.pricelist.getUserSelected(self.datakey);
                let newopts = [];
                //self.userSelected = JSON.parse(JSON.stringify(self.pricelist.useroptions));
                data[self.datakey].forEach((el) => {
                    let selected = false;
                    if ( self.userSelected.find(x=> x.id == el.id) ){
                        selected = true;
                    }
                    let prod = new ploption(el.name, el.id, selected );
                    newopts.push(prod);
                });

                if (newopts.length > 0) {
                    //newopts.sort((a, b) => a.name.localeCompare(b.name));
                    self.options = newopts;
                    self.renderOptions();

                } else {
                    self.setStatus('disabled');
                }
                self.loadDependent();

            },
            error: function () {
                console.log('Ajax failed. query:' + self.apiendpoint + ' data=' + JSON.stringify({id: self.ids}) );
               // message('Ajax failed');
            }
        })

    }

    updateOptions(datakey){
        let option = this.options.find( (op) => op.id == datakey );
        option.isSelected = !option.isSelected;
        this.renderReport();
        let $viewelement = this.view().find('.selected-container').find('li[data-key='+datakey+']');
        if (option.isSelected){
            $viewelement.addClass('true');
        } else {
            $viewelement.removeClass('true');
        }
        return option.isSelected;
    }

    //loads depended dropdowns if set
    loadDependent(){
        let index = this.pricelist.plcategories.findIndex(x=> x.datakey == this.datakey);
        if ( this.pricelist.plcategories.length > ( index + 1 ) && this.pricelist.plcategories[ index + 1].dependency == this.datakey ){
            this.pricelist.plcategories[ index + 1 ].getOptions();
        }
    }

    //redners the available options
    renderOptions(){
        this.view().addClass('loading');
        if (this.options.length > 0){
            let template = this.options.map((option) => {

                return `<li class="${option.isSelected ? true : '' } update-option"
                        data-key="${option.id}"><span class="checkbox" ></span>
                        <span class="name">${option.name}</span>
                        <hr></li>` }).join('');

            this.view().find(' ul.select').html(template);

        } else {

        }

        this.renderReport();
        this.renderAuswahl();
        this.setStatus('loaded');

    }

    //render tooltip
    renderTooltip(element){

       let  template = this.options.filter(x=> x.isSelected == true).map( option =>{
           return `${option.name}<br>`
       }).join('')

        var trigger = $(element);

        var instance = new Tooltip(trigger,{
            title: template,
            trigger: "click",
            html: true,
            placement: 'bottom'
        });

        this.tooltip = instance;
        this.tooltip.show();
    }

    removeTooltip(){
        this.tooltip.dispose();
    }

    //renders the selected list in the dropdown
    renderReport(){
        let self = this;
        self.view().find('.report').html('');
        let options = this.options.filter(x=> x.isSelected);
        if (options.length > 0){
            options.forEach(function (element) {
                // let name = self.view().find('li[data-key='+element.id+'] .name').html();
                if (element.isSelected){
                    self.view().find('.report').append( '<li class="update-option" data-key="'+element.id+'"><span class="name">' + element.name + '</span><span class="icon"></span></li>' )
                }
            })

        } else if ( this.options.length > 0 ) {
            self.view().find('.report').append( '<li class="">'+translations.auswahl_k+'</li>' )
        } else {

        }

    }

    //sets selected number in the nav
    renderAuswahl(){
        this.view().closest('.pricelist').find('.nav a[data-key='+this.datakey+'] .num').html( this.view().find('ul.select').find('li.true').length );
    }

    //creates the dropdown tab and navigation for the category
    render() {
        return `<div class="dropdown ${this.status}" data-key="${this.datakey}" >
             <div class="report-container">
             <div class="title">${translations.auswahl}</div>
               <ul class="report">
             
              </ul>
              <a class="confirm-change" href="">${translations.auswahl_b}</a>
             </div>
           
            <div class="selected-container">
            <ul class="select">
               
           </ul>
           
             <div class="disabled-msg">${translations.bitte_ein_produkt_auswahlen}</div>
            <div class="loading-msg lds-dual-ring"></div>
            <div class="empty-msg">${translations.nichts_gefunden}</div>
            </div>
           
            
            
       </div>`;

    }
}